// Import the functions you need from the SDKs you need
import { initializeApp} from "firebase/app";
import { getAuth, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getCookie } from "./helper";
import { child, get, ref } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: "https://causalfunnel-21-dailystats.firebaseio.com/",
  // databaseURL: "https://test-database-needs-del.firebaseio.com/",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBSE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
// https://causalfunnel-21-dailystats.firebaseio.com/
// https://test-database-needs-del.firebaseio.com/

const defaultNudgeApp = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://causalfunnel-21-dailyemails.firebaseio.com/",
  },
  "defaultNudgeProperties"
);

const bookingPlatformApp = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://causalfunnel-21-booking-platform.firebaseio.com/",
  },
  "bookingPlatformProperties"
);

// const abTesting = initializeApp(
//   {
//     ...firebaseConfig,
//     databaseURL: "https://causalfunnel-21-dailystats.firebaseio.com",
//   },
// );

const testnudge = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://causalfunnelnudges.firebaseio.com/",
  },
  "testnudge"
);

const testApp = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://test-database-needs-del.firebaseio.com/",
  },
  "test"
);




const firebaseDailyEmailsConfig = initializeApp(
  {
    databaseURL: "https://causalfunnel-21-dailyemails.firebaseio.com/",
  },
  "emails"
);
// https://causalfunnel-21-dailyemails.firebaseio.com/

const firebaseNewFirstTouchConfig = initializeApp(
  {
    databaseURL: "https://delete-106.firebaseio.com/",
  },
  "newfirsttouchdata"
);
//https://delete-106.firebaseio.com/

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);

// Experimenting
// console.log("db", ref(db));
// const dbRef = ref(db);
// async function checkWhatsHappenning(dbRef){
//   const snapshot = await get(child(dbRef, `${"omkar"}`));
//   return console.log(snapshot.exists());
// }
// checkWhatsHappenning(dbRef);

// nudge database
const defaultNudgeDb = getDatabase(defaultNudgeApp);
const bookingPlatformDb = getDatabase(bookingPlatformApp);

// test database
const testDb = getDatabase(testApp);

//test nudge
const testNudge = getDatabase(testnudge);

// Daily Emails database
const dbEmail = getDatabase(firebaseDailyEmailsConfig);
// console.log("dbEmail",auth)
// New first last touch database
const dbTouch = getDatabase(firebaseNewFirstTouchConfig);

// Storage for nudge images
const storage = getStorage(app, "gs://causalfunnel-21.appspot.com/");

const handleChangePassword = async (currentPassword,newPassword) => {
  try {
    const user = auth.currentUser;
    console.log('user',user);
    const email=getCookie('user');
    // Reauthenticate the user with the current password
    const credential = EmailAuthProvider.credential(email, currentPassword);
    await reauthenticateWithCredential(user, credential);

    // Update the password
    await updatePassword(user, newPassword);

    console.log('Password changed successfully!');
    return "success";
  } catch (error) {
    console.error('Error changing password:', error.message);
    return "incorrect";
  }
};

const nudges = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://causalfunnelnudges.firebaseio.com/"
  },
  "predefinednudges"
);

const nudgesCompany = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://causalfunnelnudges.firebaseio.com/",
    // ignoreUndefinedProperties: true,
  },
  "CompanyProds"
);

const newsletter = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://causalfunnelnudges.firebaseio.com/",
    // ignoreUndefinedProperties: true,
  },
  "Newsletter"
);

const convertedDataApp = initializeApp(
  {
    ...firebaseConfig,
    databaseURL: "https://converted-data.firebaseio.com/",
  },
  "ConvertedData"
);

const convertedDataDb = getDatabase(convertedDataApp);

export { auth, db, defaultNudgeDb,bookingPlatformDb, testDb, dbEmail, dbTouch, storage,nudges, nudgesCompany, newsletter,  handleChangePassword,testNudge, convertedDataDb };